// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-to-list-modal {
  background: var(--card-bg);
  border-radius: 16px;
  width: 100%;
  max-width: 420px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.add-to-list-modal .modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color);
}

.add-to-list-modal .modal-header h2 {
  margin: 0;
  font-size: 16px;
  color: var(--text-primary);
  font-weight: 600;
}

.add-to-list-modal .close-btn {
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: var(--text-secondary);
  padding: 0 4px;
}

.add-to-list-body {
  padding: 12px 8px 16px;
  flex: 1 1;
}

.no-lists-hint {
  color: var(--text-secondary);
  font-size: 13px;
  padding: 4px 12px 8px;
  margin: 0;
}

.list-items {
  list-style: none;
  margin: 0;
  padding: 0;
}

.list-item {
  border-bottom: 1px solid var(--border-color);
}

.list-toggle-btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  color: var(--text-primary);
  font-size: 14px;
  transition: background 0.15s;
}

.list-toggle-btn:hover {
  background: var(--hover-bg, rgba(255,255,255,0.06));
}

.list-toggle-btn:disabled {
  opacity: 0.6;
  cursor: wait;
}

.list-check {
  width: 18px;
  height: 18px;
  border: 2px solid var(--border-color);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
  color: var(--accent-color, #4a9eff);
  background: transparent;
  transition: border-color 0.15s;
}

.list-toggle-btn.is-member .list-check {
  border-color: var(--accent-color, #4a9eff);
  background: var(--accent-color, #4a9eff);
  color: #fff;
}

.list-name {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-count {
  color: var(--text-secondary);
  font-size: 12px;
  flex-shrink: 0;
}

.create-list-row {
  display: flex;
  gap: 8px;
  padding: 12px 12px 0;
}

.create-list-input {
  flex: 1 1;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--input-bg, var(--card-bg));
  color: var(--text-primary);
  font-size: 14px;
  outline: none;
}

.create-list-input:focus {
  border-color: var(--accent-color, #4a9eff);
}

.create-list-btn {
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  background: var(--accent-color, #4a9eff);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.create-list-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.create-list-error {
  color: var(--error-color, #e05252);
  font-size: 12px;
  padding: 4px 12px 0;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/AddToListModal/AddToListModal.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".add-to-list-modal {\r\n  background: var(--card-bg);\r\n  border-radius: 16px;\r\n  width: 100%;\r\n  max-width: 420px;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.add-to-list-modal .modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 16px 20px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.add-to-list-modal .modal-header h2 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.add-to-list-modal .close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 22px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  padding: 0 4px;\r\n}\r\n\r\n.add-to-list-body {\r\n  padding: 12px 8px 16px;\r\n  flex: 1;\r\n}\r\n\r\n.no-lists-hint {\r\n  color: var(--text-secondary);\r\n  font-size: 13px;\r\n  padding: 4px 12px 8px;\r\n  margin: 0;\r\n}\r\n\r\n.list-items {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.list-item {\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.list-toggle-btn {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 10px 12px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.list-toggle-btn:hover {\r\n  background: var(--hover-bg, rgba(255,255,255,0.06));\r\n}\r\n\r\n.list-toggle-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: wait;\r\n}\r\n\r\n.list-check {\r\n  width: 18px;\r\n  height: 18px;\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  flex-shrink: 0;\r\n  color: var(--accent-color, #4a9eff);\r\n  background: transparent;\r\n  transition: border-color 0.15s;\r\n}\r\n\r\n.list-toggle-btn.is-member .list-check {\r\n  border-color: var(--accent-color, #4a9eff);\r\n  background: var(--accent-color, #4a9eff);\r\n  color: #fff;\r\n}\r\n\r\n.list-name {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.list-count {\r\n  color: var(--text-secondary);\r\n  font-size: 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.create-list-row {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 12px 12px 0;\r\n}\r\n\r\n.create-list-input {\r\n  flex: 1;\r\n  padding: 8px 10px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--input-bg, var(--card-bg));\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  outline: none;\r\n}\r\n\r\n.create-list-input:focus {\r\n  border-color: var(--accent-color, #4a9eff);\r\n}\r\n\r\n.create-list-btn {\r\n  padding: 8px 14px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  background: var(--accent-color, #4a9eff);\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.create-list-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.create-list-error {\r\n  color: var(--error-color, #e05252);\r\n  font-size: 12px;\r\n  padding: 4px 12px 0;\r\n  margin: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
